import React from "react";
import { Box } from "@comfama/comfama-ui";
import Modal from "../../molecules/modal/modal";
import DiscTestContent from "../../molecules/disc-test-content/DiscTestContent";


export enum ModalSuccesType {
    selfEmployment = "selfEmployment",
    findJobAMVA = "findJobAmva",
    finJobRegions = "findJobRegions",
}

interface FormMentoriaTalentoModalSwitcherProps {
    type: ModalSuccesType;
    metaTitulo: string;
    modalContent: {
        image: string;
        title: string;
        textButton: string;
        url: string;
        body: React.ReactNode;
    };
}

export const FormMentoriaTalentoModalSwitcher = ({
    type,
    modalContent,
    metaTitulo,
}: FormMentoriaTalentoModalSwitcherProps) => {

   const { image = "", title = "", textButton = "", url = "", body } = modalContent;


    switch (type) {
        case ModalSuccesType.selfEmployment:
            return (
                <Modal
                    image={image}
                    title={title}
                    textButton={
                        textButton
                    }
                    url={url}
                    classNames={{
                        title: "m-modal__title--max",
                        ctaBtn: "a-button__big a-button__center",
                    }}
                >
                    <Box className={`o-form-${metaTitulo}__content-modal`}>
                        {body}
                    </Box>
                </Modal>
            );
        case ModalSuccesType.findJobAMVA:
            return (
                <Modal
                    image={image}
                    title={title}
                    textButton={
                        textButton
                    }
                    url={url}
                    classNames={{
                        title: "m-modal__title--max",
                        ctaBtn: "a-button__big a-button__center",
                        ctaBtnVariant: 'a-button__magenta-modal-aceleradora',
                        modal: 'm-modal--big-content'
                    }}
                >
                    <Box className={`o-form-${metaTitulo}__content-modal`}>
                        {body}
                        <DiscTestContent />
                    </Box>
                </Modal>
            );
        case ModalSuccesType.finJobRegions:
            return (
                <Modal
                    image={image}
                    title={title}
                    textButton={
                        textButton
                    }
                    url={url}
                    classNames={{
                        title: "m-modal__title--max",
                        ctaBtn: "a-button__big a-button__center",
                    }}
                >
                    <Box className={`o-form-${metaTitulo}__content-modal`}>
                        {body}
                    </Box>
                </Modal>
            );
    }

    return <></>;
};
